
import React from 'react';
import { Send, Upload } from 'lucide-react';

const InputArea = ({ 
  input, 
  setInput, 
  handleSendMessage, 
  setShowUploadModal, 
  loading, 
  fileUploading, 
  fileUploaded 
}) => {
  return (
    <div className="border-t border-gray-200 p-4 overflow-hidden">
      <div className="flex items-center min-w-0">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={fileUploaded ? "Ask a question..." : "Upload a file first..."}
          className="flex-1 min-w-0 p-2 border-none focus:ring-0 focus:outline-none"
          onKeyPress={(e) => {
            if (e.key === 'Enter' && !e.shiftKey && fileUploaded) {
              e.preventDefault();
              handleSendMessage();
            }
          }}
          disabled={loading || fileUploading || !fileUploaded}
        />
        <button
          onClick={() => setShowUploadModal(true)}
          className="flex-shrink-0 p-2 text-gray-500 hover:text-primary mr-2"
          disabled={fileUploading}
        >
          <Upload className="w-5 h-5" />
        </button>
        <button
          onClick={handleSendMessage}
          className={`flex-shrink-0 p-2 rounded-full ${!fileUploaded || loading || !input.trim() ? 'bg-gray-300' : 'bg-primary hover:bg-primaryDark'} text-white`}
          disabled={loading || !input.trim() || fileUploading || !fileUploaded}
        >
          <Send className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default InputArea;